import React from "react";
import FavouritesListItem from "./FavouritesListItem";
import { FavouritesQuery$data } from "./__generated__/FavouritesQuery.graphql";

interface FavouritesListProps {
  data: FavouritesQuery$data;
}

const FavouritesList: React.FC<FavouritesListProps> = ({ data }: FavouritesListProps) => {
  const favourites = data?.nodes?.result?.edges ?? [];

  return (
    <>
      {favourites.map((item) => (
        <FavouritesListItem
          key={item?.node?.id || ""}
          taskType={item?.node?.__typename || ""}
          id={item?.node?.id || ""}
          producedBy={item?.node?.produced_by?.parents?.edges[0]?.node?.parent?.id || " "}
          title={item?.node?.produced_by?.parents?.edges[0]?.node?.parent?.title || " "}
          created={item?.node?.produced_by?.parents?.edges[0]?.node?.parent?.created || " "}
          modelType={item?.node?.produced_by?.parents?.edges[0]?.node?.parent?.model_type || " "}
          description={item?.node?.produced_by?.parents?.edges[0]?.node?.parent?.description || " "}
        />
      ))}
    </>
  );
};

export default FavouritesList;
